'use strict'
const ServiceFactory = require('factories/Service'),
	GeoLocationProvider = new (require('providers/GeoLocationProvider'))();

module.exports = ServiceFactory.create({
    displayName : 'Geolocation',
    methods : {
		detect : GeoLocationProvider.detect
	}
})



// WEBPACK FOOTER //
// providers/services/GeoLocation.js